import React from "react"
import { useRenderContext } from "../../render-context"
import Playlist from "./components/playlist"
import Artist from "./components/artist"
import Album from "./components/album"
import Track from "./components/track"
import Spotify from "./components/spotify"

const getAlignmentStyle = alignment =>
  ({
    left: { marginRight: "auto" },
    center: { marginLeft: "auto", marginRight: "auto" },
    right: { marginLeft: "auto" }
  }[alignment])

export default function SpotifyEmbed({ data, attributes, node }) {
  const { target, mode } = useRenderContext()

  const editing = mode === "editing"
  const { spotify, alignment } = data

  const editingClass = editing ? "pointer-events-none" : ""

  if (!spotify) return null
  if (target !== "email") {
    return (
      <div {...attributes}>
        <iframe
          className={editingClass}
          style={getAlignmentStyle(alignment)}
          title={`Spotify embed for ${spotify.title}`}
          src={`https://open.spotify.com/embed/${spotify.type}/${spotify.id}`}
          width="300"
          height="380"
          border="0"
          allowtransparency="true"
          allow="encrypted-media"
        />
      </div>
    )
  }
  return (
    <Spotify
      id={spotify.id}
      attributes={attributes}
      href={spotify.properties.external_urls?.spotify}
      alignment={alignment}
      node={node}
    >
      <div>
        {spotify.type === "playlist" ? (
          <Playlist
            title={spotify.title}
            images={spotify.properties.images[0].url}
            display_name={spotify.properties.owner.display_name}
            editing={editing}
          />
        ) : spotify.type === "artist" ? (
          <Artist
            images={spotify.properties.images[0].url}
            title={spotify.title}
            editing={editing}
            tracks={spotify.properties.tracks}
          />
        ) : spotify.type === "track" ? (
          <Track
            title={spotify.title}
            images={spotify.properties.album?.images[0].url}
            artists_name={spotify.properties.artists[0].name}
            editing={editing}
          />
        ) : spotify.type === "album" ? (
          <Album
            title={spotify.title}
            images={spotify.properties.images[0].url}
            artists_name={spotify.properties.artists[0].name}
            editing={editing}
          />
        ) : null}
      </div>
    </Spotify>
  )
}
